import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";
import LandingPage from "./LandingPage";
import LimjiApp from "./business-ai-toolkit";
import SignInPage from "./SignInPage";
import SignUpPage from "./SignUpPage";
import AccountPage from "./AccountPage";
import PrivacyPage from "./PrivacyPage";
import TermsPage from "./TermsPage";

export default function App() {
  const { isLoaded } = useUser();

  if (!isLoaded) return null;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"          element={<LandingPage />} />
        <Route path="/sign-in/*" element={<SignInPage />} />
        <Route path="/sign-up/*" element={<SignUpPage />} />
        <Route path="/account"   element={<AccountPage />} />
        <Route path="/app"       element={<LimjiApp />} />
        <Route path="/privacy"   element={<PrivacyPage />} />
        <Route path="/terms"     element={<TermsPage />} />
        <Route path="*"          element={<LimjiApp />} />
      </Routes>
    </BrowserRouter>
  );
}
